// Roles habilitados para aprobar/rechazar y editar tarjetas en Aprobología.
const APPROVER_ROLES = ['aprobologo', 'equipo_bo'];

/**
 * `ROL` se guarda en localStorage como los Groups del login concatenados por
 * coma (p. ej. "equipo_bo,aprobologo"), por eso no sirve comparar el string
 * completo con igualdad estricta: hay que mirar grupo por grupo.
 */
export const canApprove = (rol: string | null): boolean =>
  (rol ?? '')
    .split(',')
    .some(group => APPROVER_ROLES.includes(group.trim()));
